module.exports = __webpack_public_path__ + "img/icon-intestine-sand.e3c7a259.svg";